import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import _uniq from 'lodash/uniq';
import React, { useContext } from 'react';
import { Trigger, Anchor } from '@zillow/constellation';
import { yieldCallback } from '@zillow/yield-callback';
import { event } from '@zillow/universal-analytics';
import getConfig from 'next/config';
import { usePageProps, getCmsInfoForPage } from '@zillow/zrs-cms';
import BlocksContext from '../components/BlockList/BlockContext.js';
import BlockModalDialog from '../blocks/ModalDialog.js';

var _excluded = ["triggerLink", "href"];

// TODO: find more efficient way to do this...
function getBlockById(blocks, id) {
  var object;
  blocks.some(function iter(block) {
    var _block$attrs;
    if ((block === null || block === void 0 || (_block$attrs = block.attrs) === null || _block$attrs === void 0 ? void 0 : _block$attrs.id) === id) {
      object = block;
      return true;
    }
    return Array.isArray(block.innerBlocks) && block.innerBlocks.some(iter);
  });
  return object;
}
var isValidTrigger = function isValidTrigger(target) {
  return /#(.*)/gm.test(target);
};
function withTrigger(WrapperComponent) {
  return function WithTrigger(props) {
    var triggerLink = props.triggerLink;
      props.href;
      var rest = _objectWithoutProperties(props, _excluded);
    var _useContext = useContext(BlocksContext),
      rootBlocks = _useContext.rootBlocks;
    var pageProps = usePageProps();
    if (!rootBlocks) {
      // Either context not provided, or rootBlocks is really
      // undefined. so quit without adding trigger.
      return /*#__PURE__*/React.createElement(WrapperComponent, props);
    }
    if (!triggerLink || !isValidTrigger(triggerLink)) {
      return /*#__PURE__*/React.createElement(WrapperComponent, props);
    }
    var triggerDetails = getBlockById(rootBlocks, triggerLink.substring(1));
    if (!triggerDetails || (triggerDetails === null || triggerDetails === void 0 ? void 0 : triggerDetails.blockName) !== 'constellation/modal-dialog') {
      return /*#__PURE__*/React.createElement(WrapperComponent, props);
    }
    var triggerComponent = function triggerComponent(triggerProps) {
      return /*#__PURE__*/React.createElement(BlockModalDialog, _extends({
        triggerProps: triggerProps
      }, triggerDetails));
    };
    return /*#__PURE__*/React.createElement(Trigger, {
      triggered: triggerComponent,
      onOpen: function onOpen() {
        event({
          // https://dataportal.zillowgroup.net/event-registry/2048
          envelope: {
            event_type_id: '5030',
            event_type_version_id: '1',
            event_template_id: '297',
            event_template_version_id: '1'
            // Master ID: 2284.2.126.1
          },
          clickstream_trigger: {
            trigger_type_nm: 'interaction',
            trigger_location_nm: 'cms',
            trigger_source_nm: 'cms_modal',
            trigger_object_nm: 'no_trigger_object'
          },
          semantic: {
            semantic_event_nm: 'cms_open'
          },
          cms_info: Object.assign({
            block_id: props.id || '',
            block_type_cd: 'modal_dialog'
          }, getCmsInfoForPage(pageProps))
        });
      },
      onClose: function onClose() {
        event({
          // https://dataportal.zillowgroup.net/event-registry/2051
          envelope: {
            event_type_id: '2051',
            event_type_version_id: '1',
            event_template_id: '126',
            event_template_version_id: '1'
            // Master ID: 2284.2.126.1
          },
          clickstream_trigger: {
            trigger_type_nm: 'interaction',
            trigger_location_nm: 'cms',
            trigger_source_nm: 'cms_modal',
            trigger_object_nm: 'no_trigger_object'
          },
          semantic: {
            semantic_event_nm: 'cms_close'
          },
          cms_info: Object.assign({
            block_id: props.id || '',
            block_type_cd: 'modal_dialog'
          }, getCmsInfoForPage(pageProps))
        });
      }
    }, /*#__PURE__*/React.createElement(WrapperComponent, _extends({}, rest, {
      as: 'button',
      onClick: yieldCallback(function (e) {
        var _props$onClick;
        e.preventDefault();
        (_props$onClick = props.onClick) === null || _props$onClick === void 0 || _props$onClick.call(props, e);
      })
    })));
  };
}
var AnchorWithTrigger = withTrigger(Anchor);

// Used to wrap components in anchors if link attributes is present in block attributes.
function withAnchor(WrapperComponent) {
  var WithAnchorComponent = function WithAnchorComponent(props) {
    var link = props.attrs.link;
    if (link !== null && link !== void 0 && link.url) {
      var rel = [];
      if (link.sponsored) {
        rel.push('nofollow');
        rel.push('sponsored');
      }
      if (link.nofollow) {
        rel.push('nofollow');
      }
      return /*#__PURE__*/React.createElement(AnchorWithTrigger, {
        triggerLink: link.url,
        href: link.url,
        rel: rel.length > 0 ? _uniq(rel).join(' ') : undefined,
        target: link.opensInNewTab ? '__blank' : undefined
      }, /*#__PURE__*/React.createElement(WrapperComponent, props));
    }
    return /*#__PURE__*/React.createElement(WrapperComponent, props);
  };
  return WithAnchorComponent;
}
function getNextAppConfig(config) {
  var _ref = getConfig() || {},
    publicRuntimeConfig = _ref.publicRuntimeConfig,
    serverRuntimeConfig = _ref.serverRuntimeConfig;
  if (publicRuntimeConfig && typeof publicRuntimeConfig[config] !== 'undefined') {
    return publicRuntimeConfig[config];
  } else if (serverRuntimeConfig && typeof serverRuntimeConfig[config] !== 'undefined') {
    return serverRuntimeConfig[config];
  }
  return process.env[config];
}

export { getBlockById, getNextAppConfig, isValidTrigger, withAnchor, withTrigger };
